<div class="flex gap-2" [formGroup]="form">
    <app-input-date name="dataInizioValidita" class="my-date-input" label="data inizio validità" [form]="form"></app-input-date>
    <app-input-date name="dataFineValidita" class="my-date-input" label="data fine validità" [form]="form"></app-input-date>
</div>